<template>
  <div>
    <div class="tabs">
      <button
        v-for="tab in tabs"
        :key="tab.name"
        class="tab"
        :class="{ 'active': active == tab.name }"
        @click.prevent="change(tab)"
      >
        {{ tab.name }}
        <span v-if="tab.indicator" class="tab-indicator">{{ tab.indicator }}</span>
      </button>
      <div class="tab-remainder"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    initialTab: String
  },

  data() {
    return {
      tabs: [],
      active: ""
    };
  },

  mounted() {
    this.tabs = this.$children;
    let tab = this.initialTab || this.tabs[0];
    this.active = tab.name;
  },

  methods: {
    change(tab) {
      this.active = tab.name;
      this.$emit("change", tab.name);
    }
  }
};
</script>